import React from 'react';

export default function Juice5(props) {
    return (
        <svg
            width="23px"
            height="22px"
            viewBox="0 0 23 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            {/* Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch */}
            <title>4-5</title>
            <desc>Created with Sketch.</desc>
            <defs />
            <g
                id="Engagement"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <g id="4-5" fill="#000000" fillRule="nonzero">
                    <g id="icons8-hygrometer-copy">
                        <path
                            className={props.className}
                            // eslint-disable-next-line
                            d="M18,0 L18,2 L23,2 L23,0 L18,0 Z M7,0.09375 L6.15625,1.46875 C6.15625,1.46875 4.644531,3.910156 3.125,6.78125 C2.367188,8.21875 1.582031,9.765625 1,11.1875 C0.417969,12.609375 0,13.871094 0,15 C0,18.855469 3.144531,22 7,22 C10.855469,22 14,18.855469 14,15 C14,13.871094 13.582031,12.609375 13,11.1875 C12.417969,9.765625 11.632813,8.21875 10.875,6.78125 C9.355469,3.910156 7.84375,1.46875 7.84375,1.46875 L7,0.09375 Z M20,5 L20,7 L23,7 L23,5 L20,5 Z M18,10 L18,12 L23,12 L23,10 L18,10 Z M20,15 L20,17 L23,17 L23,15 L20,15 Z M18,20 L18,22 L23,22 L23,20 L18,20 Z"
                            id="Shape"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
